import { useRouter } from 'next/router'

import useSWR from 'swr'

import { ResourceDocument, ResourceFragment } from '@/generated/contentful'

import { client } from '@/lib/contentful/client'

import { serializeCacheKey, useSlug } from '../../../../lib/contentful/utils'

export function useResource(): { error: string } | { data: ResourceFragment } {
	const slug = useSlug()
	const { locale, isPreview } = useRouter()

	const { data } = useSWR(slug && serializeCacheKey('resource', { slug, locale }), () =>
		client({ preview: isPreview }).request(ResourceDocument, {
			where: {
				slug,
				...(isPreview ? {} : { status: true })
			},
			limit: 1,
			locale,
			preview: isPreview
		})
	)

	if (!slug) return { error: 'Cannot find slug.' }

	const item = data?.resourceCollection?.items[0]

	if (!item) return { error: `Cannot find entry at ${slug}.` }

	return { data: item }
}
